
export default {
    data() {
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            zoom: 10,
            center: [0, 0],
            geojson: null,
            fillColor: "#041e42",
            prefix: ' © <a href="https://leafletjs.com" title="A JavaScript library for interactive maps">Leaflet</a> | Contributeurs <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a>'
        };
    },
    computed: {
        styleFunction() {
            const fillColor = this.fillColor;
            return () => {
                return {
                    weight: 3,
                    color: "#ce1141",
                    opacity: 1,
                    fillColor: fillColor,
                    fillOpacity: 0.2
                }
            }
        }
    },
    props: {
        latitude: {
            default: 0,
            type: Number
        },
        longitude: {
            default: 0,
            type: Number
        },
        slug: String,
        nearCities: Array
    },
    async created() {
        this.center = [this.latitude, this.longitude];
        const response = await fetch(this.$config.baseApiURL + '/cities/' + this.slug + '/geojson');
        this.geojson = await response.json();

    }
};
